<mat-sidenav-container>
	<mat-sidenav #sidenav mode="side" position="end">
		<app-document-viewer (close)="toggleSlide(); documentLoadUnsubscriber$.next()" *ngIf="viewDocument"
			[documentDetails]="selectedDocumentDetails"></app-document-viewer>

		<app-loader *ngIf="viewEmail && !selectedEmailDetails"></app-loader>

		<div class="email-container" *ngIf="viewEmail && selectedEmailDetails">

			<div class="heading">
				<div class="subject">
					<p>
						<span class="label">Subject: </span>
						<span>{{ selectedEmailDetails?.subject }}</span>
					</p>

					<p>
						<span class="label">Attachments: </span>
						<span>{{ selectedEmailDetails?.attachmentsCount }}</span>
					</p>
				</div>

				<div class="actions">
					<button mat-icon-button (click)="toggleSlide();">
						<mat-icon>close</mat-icon>
					</button>
				</div>
			</div>

			<hr />

			<p [innerHTML]="selectedEmailDetails?.contentHtml"></p>
		</div>
	</mat-sidenav>

	<mat-sidenav-content [class.opened]="isOpened">
		<div class="main-container">
			<h3>My Cloud</h3>

			<div class="main-form">
				<p class="empty-message-container" *ngIf="!documents?.length">There are no documents in your cloud yet!
				</p>

				<ng-container *ngIf="documents?.length">
					<div class="document-container" *ngFor="let document of documents">
						<div class="document-info-container">
							<h4 class="document-heading">{{ document.documentName }}</h4>
							<div class="document-info">
								<span class="label">Subject: </span>
								<span class="value">{{ document.emailSubject }}</span>
							</div>
							<div class="document-info">
								<span class="label">Received on: </span>
								<span class="value">{{
									moment.parseZone(document.documentReceivedOn).format('MM/DD/YYYY hh:mm A') }}</span>
							</div>
						</div>
						<div class="document-info-actions">
							<button mat-icon-button
								(click)="selectedDocuments[0] = document; navigateWithData('..', selectedDocuments)">
								<mat-icon class="highlighted">add_circle_outline</mat-icon>
							</button>
							<button mat-icon-button (click)="showEmail(document)">
								<mat-icon>email</mat-icon>
							</button>
							<button mat-icon-button (click)="showDocument(document)">
								<mat-icon>visibility</mat-icon>
							</button>
						</div>
					</div>
				</ng-container>
			</div>
		</div>

		<action-button-carousel>
			<ng-template #buttonsTemplate>
				<action-button [icon]="ButtonIcons.Exit" [name]="'Back'" (click)="navigateWithData('..', null)">
				</action-button>
			</ng-template>
		</action-button-carousel>
	</mat-sidenav-content>
</mat-sidenav-container>